import {merge} from "lodash";
import partnerMessages from "@i18n_messages_de"

export default merge({}, partnerMessages);